import React, {useEffect, useState} from "react";
import PageTransition from "../PageTransition";
import Activation from "../../../components/Activation/Activation";
import {ActivationType, validateToken} from "../../activation/activationApi";
import RecoveryRequestForm from "./stages/request/passwordRecoveryRequestForm";
import PasswordRecoveryForm from "./stages/password-recovery/passwordRecoveryForm";
import {useParams} from "react-router-dom";
import { Spacer} from "../../../common";
import {Alert, Box, CircularProgress, Typography} from "@mui/material";
import I18n from "i18n-js";
import ActivationSuccess from "../../../components/Activation/ActivationSuccess";
import ActivationError from "../../../components/Activation/ActivationError";

export default function PasswordRecoveryStages() {
  const [stage, setStage] = useState<string>('request');
  const [email, setEmail] = useState<string>('');
  const [token, setToken] = useState<string>('');
  const params = useParams();

  function onRequestSent(email: string) {
    setEmail(email);
    setStage('activation');
  }

  function onActivationSuccess(token: string) {
    setToken(token);
    setStage('password-recovery');
  }

  function onPasswordChanged() {
    setStage('success');
  }

  async function validateParamsToken() {
    setStage('loading');
    // @ts-ignore It's already validated at this point that params.token is not undefined
    const token: string = params.token;
    const response = await validateToken(token, ActivationType.PASSWORD);
    const data = response.data;

    if (!data.success) {
      setStage('invalidToken');
    } else {
      onActivationSuccess(token);
    }
  }

  useEffect(() => {
    if (params.token !== undefined) {
      // Hide the default stage until token validation is done
      setStage('loading');

      validateParamsToken();
    }
  }, []);

  return (
    <>
      {
        stage === 'request'
          ? (
            <PageTransition direction={1}>
              <RecoveryRequestForm
                onRequestSent={onRequestSent}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'activation'
          ? (
            <PageTransition direction={1}>
              <Activation
                onActivationSuccess={onActivationSuccess}
                type={ActivationType.PASSWORD}
                email={email}
                message={
                  <>
                    <Spacer h={1}/>
                    <Alert severity="info">
                      <Typography variant="body1" sx={{fontWeight: "bold"}}>
                        {I18n.t("PasswordRecoveryRequest.activation.title")}
                      </Typography>
                      <Typography variant="body1">
                        {I18n.t("PasswordRecoveryRequest.activation.description")} <br/>
                        {I18n.t("PasswordRecoveryRequest.activation.description2")}
                      </Typography>
                    </Alert>
                    <Spacer h={1}/>
                  </>
                }
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'password-recovery'
          ? (
            <PageTransition direction={1}>
              <PasswordRecoveryForm
                token={token}
                onPasswordChanged={onPasswordChanged}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'success'
          ? (
            <PageTransition direction={1}>
              <ActivationSuccess
                messageCategory={"PasswordRecoveryRequest.passwordChanged"}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'error'
          ? (
            <PageTransition direction={1}>
              <ActivationSuccess
                messageCategory={"PasswordRecoveryRequest.passwordError"}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'invalidToken'
          ? (
            <PageTransition direction={1}>
              <ActivationError
                messageCategory={"Activation.invalidTokenPage"}
                onlyContent={false}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'loading'
          ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <CircularProgress/>
            </Box>
          )
          : ''
      }
    </>
  );
}